
import { ColumnRank, ColumnName, ColumnNoc, ColumnQualification, ColumnDifference, ColumnExpander } from "components/common/TableColumns"
//import Label from "components/general/Label"
import { findArray, RscFromStore } from 'helpers/utils'
import SportCode from 'components/common/SportCode'
import { getRscObject } from 'helpers/rsc';
import Label from "components/general/Label"


export function TableColumnsTeams(gender, phase, breakPoint) {
    let headerClassNameForTotal = 'text-end w-10'
    if (breakPoint === 'sm' || breakPoint === 'xs') headerClassNameForTotal = 'text-end';
    return (
        [
            ColumnRank({ disableSort: true }),
            ColumnNoc({ disableSort: true }),
            ColumnName({ disableSort: true }),
            ...getApparatusColumns(gender, breakPoint),
            ColumnApparatus({ label: "HeaderTotalScoreCr", code: "REPORTED", headerClassName: headerClassNameForTotal }),
            ...getQualColumn(phase),
            ...getGapColumn(phase),
            ColumnExpander({ type: 'alwaysTrue' })
        ]
    )
}

function getApparatusColumns(gender, breakPoint) {
    if (breakPoint === 'sm' || breakPoint === 'xs') return [];
    if (gender === 'M') return [
        ColumnApparatus({ code: "FX" }),
        ColumnApparatus({ code: "PH" }),
        ColumnApparatus({ code: "SR" }),
        ColumnApparatus({ code: "VT" }),
        ColumnApparatus({ code: "PB" }),
        ColumnApparatus({ code: "HB" })
    ];

    return [
        ColumnApparatus({ code: "VT" }),
        ColumnApparatus({ code: "UB" }),
        ColumnApparatus({ code: "BB" }),
        ColumnApparatus({ code: "FX" }),
    ];
}

function getQualColumn(phase) {
    if (phase === 'QUAL') return [ColumnQualification({})];
    return [];
}

function getGapColumn(phase) {
    if (phase === 'FNL-') return [ColumnDifference({ label: "HeaderGap" })];
    return [];
}


export function ColumnApparatus({
    disableSort = true,
    className = 'text-end',
    headerClassName = 'text-end w-10',
    code = '',
    label = ""
}) {
    let rsc = RscFromStore()
    let discipline = getRscObject(rsc).discipline

    let header

    if (label === "") {
        header = <SportCode discipline={discipline} entity='@Apparatus' code={code} />
    } else {
        header = <Label data={label} />
    }

    return (
        {
            Header: header,
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort,
            id: code,
            Cell: (props) => {
                let extendedResult = findArray(props.cell.row.original.extendedResults, { er_code: [code] });
                if (extendedResult) {
                    return (extendedResult.er_value)
                }
            }
        }
    )
}





export function ColumnsTeamsLeaders(breakPoint) {
    let headerClassNameForTotal = 'text-end w-10'
    if (breakPoint === 'sm' || breakPoint === 'xs') headerClassNameForTotal = 'text-end';
    return (
        [
            ColumnRank({ disableSort: true }),
            ColumnNoc({ disableSort: true }),
            ColumnName({ disableSort: true }),
            ColumnApparatus({ label: "HeaderScore", code: "REPORTED", headerClassName: headerClassNameForTotal }),
        ]
    )
}
